// @flow
import React, { Component } from 'react';
import { Button, Label } from 'reactstrap';

type Props = {
  title: string,
  count: number,
  increment: (num: number) => void,
  decrement: (num: number) => void,
};

class Counter extends Component<Props> {
  static defaultProps = {
    title: '',
    count: 0,
    increment: () => {},
    decrement: () => {},
  };

  render() {
    let { title, count } = this.props;
    return (
      <div className="passenger-list">
        <p>
          <Label className="title">{title}</Label>
        </p>
        <ul>
          <li>
            <Button onClick={this.handleDecrement}>-</Button>
          </li>
          <li>{count}</li>
          <li>
            <Button onClick={this.handleIncrement}>+</Button>
          </li>
        </ul>
      </div>
    );
  }

  handleIncrement = () => {
    let { count, increment } = this.props;
    increment(Number(count) + 1);
  };
  handleDecrement = () => {
    let { count, decrement } = this.props;
    if (count > 0) {
      decrement(Number(count) - 1);
    }
  };
}

export default Counter;



// WEBPACK FOOTER //
// ./src/components/Flights/SearchInput/Counter.jsx